export default {
  props: ['total'],
  computed: {
    url() {
      /*let url = `/cart/`
      for (let item of store.getters.cart.items) {
        url += `${item.variant_id}:${item.quantity},`
      }
      return url*/
      return '/checkout'
    }
  },
  template: `
    <a :href="url" class="checkout-button button button--full" onclick="FFBitUtils.enhancedEcommerceCheckoutInitiated();">
      Checkout
      <span class="square-separator"></span>
      <span class="d-cart-total">
        \${{(total / 100).toFixed(2)}}
      </span>
    </a>
  `
}
